// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyBgvFLqLH-2C5PxIpcrfiuH0ci_EGO2_xc",
  authDomain: "ohya-group.firebaseapp.com",
  databaseURL: "https://ohya-group-default-rtdb.firebaseio.com",
  projectId: "ohya-group",
  storageBucket: "ohya-group.appspot.com",
  messagingSenderId: "1013614600027",
  appId: "1:1013614600027:web:b70041f15718857146c47e",
  measurementId: "G-CGDTCPLLJP",
};

const app = initializeApp(firebaseConfig, "ohyaGroupFirebase");

const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 20000;

const getNoticeContent = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    const noticeDatas = (getValue(
      remoteConfig,
      process.env.REACT_APP_FIREBASE_NOTICE || "Notice"
    ) as unknown) as {
      _value: string;
    };
    const formatNoticeData = JSON.parse(noticeDatas._value);

    return formatNoticeData;
  } catch (error) {
    console.log("Fail to fetch and activate remote config", error);
    return null;
  }
};

export { app, analytics, getNoticeContent };
